export default __webpack_public_path__ + "static/add@992-e1c7f9e2ffd620f88eac42c1499a6824.svg";